'use client';

import { faIceCream } from '@fortawesome/pro-light-svg-icons';

import { Icon } from './icon.component';

import {
  Toast,
  ToastClose,
  ToastProvider,
  ToastTitle,
  ToastViewport,
  ToastIcon,
  ToastAction,
} from '@/components/ui/toast.component';
import { useDefaultToast } from '@/components/ui/use-toast';

export function Toaster() {
  const { toasts } = useDefaultToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, icon, action, closable = true, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="flex justify-center items-center text-center gap-3">
              {icon && (
                <ToastIcon className="flex items-center justify-center w-6 h-6 text-sm rounded-full">
                  <Icon icon={icon ? icon : faIceCream} />
                </ToastIcon>
              )}
              {title && (
                <ToastTitle>
                  {title}
&nbsp;
                  {action && (
                    <ToastAction onClick={action?.onClick} altText={action?.text ?? ''}>
                      {action?.text}
                    </ToastAction>
                  )}
                </ToastTitle>
              )}
            </div>
            {closable && <ToastClose />}
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
